import React from 'react';
import { InfoBoxSize, Typography, TypographyVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { CalendarMonthContainer, NoAvailabilityForMonthInfoBox } from './CalendarMonth.styles';

interface Props {
  month: moment.Moment;
  showNoAvailabilityBadge: boolean;
  isMobile: boolean;
}

export const CalendarMonth = ({ month, showNoAvailabilityBadge, isMobile }: Props) => {
  const { translations } = useTranslations();

  const formattedMonth = month.format('MMMM Y');

  return (
    <CalendarMonthContainer id={`month-${formattedMonth}`}>
      <Typography variant={TypographyVariant.t5Sans}>{formattedMonth}</Typography>
      {showNoAvailabilityBadge && (
        <NoAvailabilityForMonthInfoBox
          subTitle={i18n('calendar.notHaveAvailability', [], translations)}
          size={InfoBoxSize.extraSmall}
          isMobile={isMobile}
        />
      )}
    </CalendarMonthContainer>
  );
};
